import { Routes, Route, Navigate } from 'react-router-dom';

import { ProtectedRoute }      from './auth/ProtectedRoute.jsx';
import { Layout }              from './components/Layout.jsx';
import { LoginPage }           from './pages/LoginPage.jsx';
import { ChangePassword }      from './pages/ChangePassword.jsx';
import { PipelineView }        from './pages/PipelineView.jsx';
import { DealsView }           from './pages/DealsView.jsx';
import { MatchmakerView }      from './pages/MatchmakerView.jsx';
import { SettingsView }        from './pages/SettingsView.jsx';
import { AccessRequestsPage }  from './pages/AccessRequestsPage.jsx';

export default function App() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/change-password" element={<ChangePassword />} />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Navigate to="/pipeline" replace />} />
                <Route path="pipeline"   element={<PipelineView />} />
                <Route path="deals"      element={<DealsView />} />
                <Route path="matchmaker" element={<MatchmakerView />} />
                <Route path="settings"   element={<SettingsView />} />

                {/* Admin/team only — clients are redirected to /pipeline */}
                <Route
                    path="access-requests"
                    element={
                        <ProtectedRoute roles={['admin', 'team']}>
                            <AccessRequestsPage />
                        </ProtectedRoute>
                    }
                />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
